"use strict";

exports.__esModule = true;
var ramda_1 = require("ramda");
var generateAppConfig = function generateAppConfig(org) {
  var config = {};
  var id = org.id,
    createdAt = org.createdAt;
  var hasLegacyDriftEmailSunset = org.createdAt > 1575982800000; //Tuesday, December 10, 2019 8:00:00AM EST
  config = ramda_1.set(ramda_1.lensProp('hasMarketingEmailPlaybooks'), !hasLegacyDriftEmailSunset, config);
  config = ramda_1.set(ramda_1.lensProp('hasSalesSequencePlaybooks'), !hasLegacyDriftEmailSunset, config);
  return config;
};
exports["default"] = generateAppConfig;